import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { MasterInformationService } from '../../../Services/master-information.service';
import { apiEndPoints } from '../../../api/apiEndPoint';
import { SharedService } from '../../../Services/shared.service';

@Component({
  selector: 'app-city-configuration',
  standalone: true,
  providers: [MessageService],
  imports: [FormsModule, CommonModule, ReactiveFormsModule, ToastrModule, ToastModule,FormsModule],
  templateUrl: './city-configuration.component.html',
  styleUrl: './city-configuration.component.css'
})
export class CityConfigurationComponent implements OnInit {

  isEditMode: boolean = false;
  configForm: FormGroup
  credentialForm: FormGroup;
  cityList: any;
  changeCityId: any;
  selectedCityId: any;
  cityConfigList: any;
  loginData: any;
searchKey:any
masterCityConfigList:any | any[] = []
  constructor(private fb: FormBuilder,
    private masterService: MasterInformationService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private sharedService: SharedService,
    private messageService: MessageService,
  ) {
    this.configForm = this.fb.group({
      cityId: ['', Validators.required],
      username: ['', Validators.required],
      password: ['', Validators.required],
      cityUrl: ['', Validators.required],
    });

    this.credentialForm = this.fb.group({
      userName: [''],
      password: ['']
    })
  }

  ngOnInit() {
    this.loginData = this.sharedService.getLoginData();
    // this.getCityConfig();
    this.onLoadCityConfig()
  }

  // ----------------------------------- Get All City List API ----------------------------------- //

  getCity() {
    this.masterService.getCityList(apiEndPoints.cityList).subscribe({
      next: (response: any) => {
        let citys

        citys = response.body.details;
        console.log(citys);
        console.log(this.cityConfigList);
        console.log(this.cityConfigList.length,'length');
        
        
    if(this.cityConfigList.length >= 1){
       this.cityList = citys.filter((apiCity:any) =>
  this.cityConfigList.some((config:any) => +config.cityId === apiCity.id)
);
console.log(this.cityList);
    }
    else{
      this.cityList = citys
    }


      },
      error: (error) => {
        this.toastr.error('An unexpected error occurred. Please try again later.', 'Error', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
          progressBar: true
        });
      }
    })
  }

  onLoadCityConfig(){
     this.masterService.cityConfigList(apiEndPoints.cityConfigList, this.changeCityId).subscribe({
      next: (response: any) => {
        if (response.isSuccess) {
          this.masterCityConfigList = response.body.details || [];
          this.cityConfigList = response.body.details;
          this.getCity();

        }
      },
      error: (error) => {
        // this.getCity();

        this.toastr.error('Error getting list. Please try again later.', 'Error', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
          progressBar: true
        });
      }
    })
  }

filterCities() {
  if (!this.searchKey) {
    this.cityConfigList = [...this.masterCityConfigList]; // reset if empty
    return;
  }

  const key = this.searchKey.toLowerCase();

  this.cityConfigList = this.masterCityConfigList.filter((city: any) =>
    Object.values(city).some(val =>
      val?.toString().toLowerCase().includes(key)
    )
  );
}
  // ----------------------------------- City Change Dropdown ----------------------------------- //

  onFilterCityChange(event: Event) {
    const selectedCityId = (event.target as HTMLSelectElement).value;
    this.changeCityId = selectedCityId;
    this.getCityConfig();
  }

  onCityChange(event: Event) {
    const selectedCityId = (event.target as HTMLSelectElement).value;
    this.selectedCityId = selectedCityId;
  }

  // --------------------------------- Open Modal --------------------------------- //

  openModal(modal: any) {
    this.configForm.enable();
    this.credentialForm.reset();
    this.configForm.reset();
    this.isEditMode = false;
    this.modalService.open(modal, {
      centered: true,
      backdrop: 'static',
      size: 'md',
    });

  }

  viewCredential(data: any, modal: any) {
    console.log(data)
    this.credentialForm.patchValue({
      userName: data.userName,
      password: data.passWord
    });
    this.modalService.open(modal, {
      centered: true,
      backdrop: 'static',
      size: 'md',
    });
  }

  // --------------------------------- Add City Configuration API --------------------------------- //

  saveConfig(type: any) {
    if (type == 'new') {
      if (this.configForm.valid) {
        const reqBody = {
          cityId: this.selectedCityId,
          userName: this.configForm.value.username,
          password: this.configForm.value.password,
          url: this.configForm.value.cityUrl,
        }

        this.masterService.cityConfig(apiEndPoints.addCityConfig, reqBody).subscribe({
          next: (response: any) => {
            if (response.isSuccess) {
              this.toastr.success(`URL Added Sucessfully.`, 'Success', {
                timeOut: 3000,
                positionClass: 'toast-top-right',
                progressBar: true
              });
              this.modalService.dismissAll();
              this.getCityConfig();
            }
          },
          error: (error) => {
            this.toastr.error('Error adding in fields. Please try again later.', 'Error', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true
            });
          }
        })
      } else {
        this.configForm.markAllAsTouched();
        this.toastr.info('Fill in all the fields.', 'Info', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
          progressBar: true
        });
      }
    } else {
      if (this.configForm.valid) {
        const reqBody = {
          cityId: this.configForm.get('cityId')?.value,
          userName: this.configForm.get('username')?.value,
          password: this.configForm.get('password')?.value,
          url: this.configForm.get('cityUrl')?.value,
        };
        console.log(reqBody)
        this.masterService.cityConfig(apiEndPoints.updateCityConfig, reqBody).subscribe({
          next: (response: any) => {
            if (response.isSuccess) {
              this.toastr.success(`URL Updated Sucessfully.`, 'Success', {
                timeOut: 3000,
                positionClass: 'toast-top-right',
                progressBar: true
              });
              this.modalService.dismissAll();
              this.getCityConfig();
            }
          },
          error: (error) => {
            this.toastr.error('Error adding in fields. Please try again later.', 'Error', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true
            });
          }
        })
      }
    }
  }

  // --------------------------------- Edit Modal --------------------------------- //

  editItem(data: any, modal: any) {
    this.isEditMode = true;
    this.getCity();

    this.configForm.patchValue({
      cityId: data.cityId,
      username: data.userName,
      password: data.passWord,
      cityUrl: data.cityUrl
    });

    this.configForm.get('cityId')?.disable();
    // this.configForm.get('username')?.disable();
    // this.configForm.get('password')?.disable();

    this.modalService.open(modal, {
      centered: true,
      backdrop: 'static',
      size: 'md',
    });
  }


  // --------------------------------- Get City Config List API --------------------------------- //

  getCityConfig() {
    this.masterService.cityConfigList(apiEndPoints.cityConfigList, this.changeCityId).subscribe({
      next: (response: any) => {
        if (response.isSuccess) {
          this.cityConfigList = response.body.details;
          // this.getCity();

        }
      },
      error: (error) => {
        // this.getCity();

        this.toastr.error('Error getting list. Please try again later.', 'Error', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
          progressBar: true
        });
      }
    })
  }

  // --------------------------------- Clear Filter --------------------------------- //

  clearFilter() {
this.searchKey = ''
this.changeCityId = ''
this.getCityConfig()
  }

  // --------------------------------- Export to excel --------------------------------- //

  exportToExcel() {

  }

  // --------------------------------- Input search --------------------------------- //

  onSearch() {

  }

}
